const ACCOUNT_VERIFICATION_EVENTS = {
  VERIFICATION_SUCCESS: 'VERIFICATION_SUCCESS',
  VERIFICATION_FAILURE: 'VERIFICATION_FAILURE',
}

export default ACCOUNT_VERIFICATION_EVENTS
